<template>
  <div class="section">
    <div style="padding-left: 20px">
      <div>
        <el-button type="success" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      </div>
      <el-form label-width="200px" label-position="left" style="margin-top: 10px">
        <el-form-item :label="$t('CargoMsg.Cargo_LimitReleaseWithoutContract')">
          <el-switch v-model="form.enableLimit" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_TrialOrderDays')">
          <el-input-number
            v-model="form.trialDays"
            :min="0"
            :max="9999"
            :controls="false"
            style="width: 200px"
          />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getOfficeConfigByName, saveOfficeConfigFunc } from '@/api/user'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { cache, cacheName } from '@/utils/cacheManager'

const CONFIG_LIMIT_RELEASE_WITHOUT_CONTRACT = 'ReleaseNumberLimitWithoutContractUpload'
const CONFIG_TRIAL_ORDER_DAYS = 'TrialOrderDays'

export default {
  name: 'ReleaseNumberConfig',
  data() {
    return {
      loading: null,
      form: {
        enableLimit: false,
        trialDays: 0
      },
      switchConfig: {},
      trialConfig: {}
    }
  },
  created() {
    this.loadConfig()
  },
  methods: {
    async loadConfig() {
      const officeId = this.$store.getters.currentOfficeId
      if (!officeId) {
        return
      }
      this.loading = getLoading4Cxt()
      try {
        const [switchRes, trialRes] = await Promise.all([
          getOfficeConfigByName({ officeId, configName: 'ReleaseNumberLimitWithoutContractUpload' }),
          getOfficeConfigByName({ officeId, configName: 'TrialOrderDays' })
        ])
        this.switchConfig = switchRes.data || {}
        this.trialConfig = trialRes.data || {}
        const switchVal = this.switchConfig.value || this.switchConfig.configValue ||
          this.switchConfig.configParentValue || this.switchConfig.configDefValue || '0'
        const trialVal = this.trialConfig.value || this.trialConfig.configValue ||
          this.trialConfig.configParentValue || this.trialConfig.configDefValue || 0
        this.form.enableLimit = String(switchVal) === '1'
        this.form.trialDays = Number(trialVal) || 0
      } finally {
        if (this.loading) {
          this.loading.close()
        }
      }
    },
    async saveHandler() {
      const officeId = this.$store.getters.currentOfficeId
      if (!officeId) {
        return
      }
      const switchValue = this.form.enableLimit ? '1' : '0'
      const trialValue = String(this.form.trialDays || 0)
      this.loading = getLoading4Cxt()
      try {
        await Promise.all([
          saveOfficeConfigFunc({
            officeId,
            configName: 'ReleaseNumberLimitWithoutContractUpload',
            configValue: switchValue,
            overrideable: this.switchConfig.overrideable,
            version: this.switchConfig.version,
            uuid: this.switchConfig.uuid
          }),
          saveOfficeConfigFunc({
            officeId,
            configName: 'TrialOrderDays',
            configValue: trialValue,
            overrideable: this.trialConfig.overrideable,
            version: this.trialConfig.version,
            uuid: this.trialConfig.uuid
          })
        ])
        await cache.load(cacheName.CONFIG)
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.loadConfig()
      } finally {
        if (this.loading) {
          this.loading.close()
        }
      }
    }
  }
}
</script>
